import styles from "../../reviewsPage/aboutsClinicSection/modal/Modal.module.scss";
import RecordingPage from "../RecordingPage";
import ReactDOM from "react-dom";
import {useEffect} from "react";

const ModalRecording = ({isOpen, onClose}) => {


    useEffect(() => {
       const keyDownHandler =  (e) =>{
           if(e.key === "Escape"){
               onClose()
           }
       }
       if(isOpen){
           document.addEventListener("keydown", keyDownHandler);
       }
    },[isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.content}>
                    <button className={styles.onClose} onClick={onClose}>X</button>
                    <div style={styles.form}>
                        <RecordingPage/>
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root')
    )
}
export default ModalRecording;